import React from 'react';
import { Link } from 'react-router-dom';

const CHANNEL_URL = "https://www.youtube.com/@sayFUCKTHATT";

// DeepDive episodes with YouTube video IDs
const episodes = [
  { id: 'ep1', title: "It's Time to Make a Decision", videoId: 'G2yrFxAU260', start: 14 },
  { id: 'ep2', title: 'What Do You WANT?', videoId: '9Qx5Kdf5nHk', start: 34 },
  { id: 'ep3', title: 'Pruning Your TREE of LIFE', videoId: 'gO1qQFa0utw', start: 0 },
  { id: 'ep4', title: 'Faith of a MUSTARD Seed', videoId: 'M_P0uZTRbVM', start: 0 },
  { id: 'ep5', title: 'How to Stop SleepWalking in Your Life', videoId: 'fQkfF2_KA2g', start: 0 },
];

function VideoEmbed({ videoId, title, start }) {
  if (!videoId) {
    return (
      <div className="video-embed-placeholder" data-testid="video-placeholder">
        <div className="video-embed-inner">
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
            <polygon points="5 3 19 12 5 21 5 3" fill="currentColor" />
          </svg>
          <p>{title}</p>
          <span>Video coming soon</span>
        </div>
      </div>
    );
  }
  const startParam = start ? `?start=${start}` : '';
  return (
    <div className="video-embed" data-testid="video-embed">
      <iframe
        src={`https://www.youtube.com/embed/${videoId}${startParam}`}
        title={title}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      />
    </div>
  );
}

export default function DeepDivePage() {
  return (
    <section data-testid="deepdive-page" className="deepdive-page">
      <div className="deepdive-hero">
        <p className="deepdive-label">The DeepDive into</p>
        <h1 data-testid="deepdive-title" className="deepdive-title">
          Cabrini's Law of F.U.C.K. T.H.A.T.T.
        </h1>
        <p className="deepdive-subtitle">
          Finally Understanding Common Knowledge — Things Happen All The Time
        </p>
      </div>

      <div className="deepdive-content">
        <div className="deepdive-intro">
          <p>
            Two hosts unpack Cabrini's Law of F.U.C.K. T.H.A.T.T. by listening to her teachings and going further.
            They analyze, question, reflect, and connect the dots — applying the philosophy to real life.
          </p>
          <p>
            Each episode explores what "Finally Understanding Common Knowledge — Things Happen All The Time"
            really means, and how the 3 Core Questions reshape decision-making:
          </p>
          <div className="deepdive-questions">
            <span>Who am I?</span>
            <span>What do I want?</span>
            <span>Why do I want it?</span>
          </div>
          <p>
            And what happens when you consistently apply the 5 Principles:
            <strong> Make a Decision. Trust Your Decision. Stay Focused. Take Inspired Action. Enjoy the Journey.</strong>
          </p>
          <p className="deepdive-callout">
            You're not listening to inspiration — it's integration.
          </p>
        </div>

        <h2 className="deepdive-section-title">Episodes</h2>

        <div className="deepdive-episodes">
          {episodes.map((ep) => (
            <div key={ep.id} className="deepdive-episode" data-testid={`episode-${ep.id}`}>
              <VideoEmbed videoId={ep.videoId} title={ep.title} start={ep.start} />
              <h3 className="episode-title">{ep.title}</h3>
            </div>
          ))}
        </div>

        <div className="deepdive-cta">
          <a
            href={CHANNEL_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="village-btn village-btn--primary"
            data-testid="youtube-channel-btn"
          >
            Watch on YouTube
          </a>
          <Link to="/life-map" className="village-btn village-btn--secondary">
            Back to Life-Map
          </Link>
        </div>
      </div>
    </section>
  );
}
